// const slideBlog = document.querySelector(".slider__grid--lg");
// const tag = slideBlog.getAttribute("data-tag");
//
// const getArticles = async () => {
//   try {
//     const data = await fetch(
//       "https://herbolario-salud-natural.myshopify.com/api/2024-07/graphql.json",
//       {
//         method: "POST",
//         headers: {
//           "Content-type": "application/json",
//           "X-Shopify-Storefront-Access-Token":
//             "504d3712007967498779ec2838ca6d31",
//         },
//         body: JSON.stringify({
//           query: `{
//                   articles(first: 10, query: "tag:${tag}") {
//                     edges {
//                     node {
//                         id
//                         title
//                         publishedAt
//                         tags
//                         content
//                         handle
//                         author {
//                             name
//                         }
//                         image{
//                             id
//                             url
//                         }
//                         blog {
//                             id
//                             title
//                         }
//                     }
//                     }
//                 }
//               }`,
//         }),
//       }
//     );
//
//     const result = await data.json();
//     drawArticles(result.data.articles.edges)
//     drawArticles(result.data.articles.edges)
//     drawArticles(result.data.articles.edges)
//   } catch (error) {
//     alert(error.message);
//   }
// };
//
// const drawArticles = (articles) => {
//     for (const {node} of articles) {
//         console.log(node)
//         slideBlog.innerHTML += `
//             <li class="slider__item fade-in cc-animate-init cc-animate-in" data-cc-animate="fade-in" data-cc-animate-delay="0.35s" style="animation-delay: 0.35s;">
//               <article class="card hover:grow-media card--article h-full relative flex flex-col justify-between" id="article-558866563165"><a href="/blogs/blog/semillas-propiedades-medicinales-y-nutricionales-para-una-vida-saludable" class="card__media relative"><div class="media block relative h-full" tabindex="-1" style="padding-top: 56.49717514124294%;">
//                 <img data-srcset="//herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=320 320w, //herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=460 460w, //herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=600 600w, //herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=700 700w, //herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=800 800w, //herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=900 900w, //herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=1200 1200w" sizes="(min-width: 1508px) calc((1380px - 48px) / 3), (min-width: 1280px) calc((100vw - 176px) / 3), (min-width: 1024px) calc((100vw - 144px) / 3), (min-width: 600px) calc((100vw - 120px) / 2), calc(100vw - 40px)" data-src="//herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=460" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201200%20599'%3E%3C/svg%3E" class="img-fit no-js-hidden" loading="lazy" width="1200" height="599" alt="Semillas: propiedades medicinales y nutricionales para una vida saludable" srcset="//herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=320 320w, //herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=460 460w, //herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=600 600w, //herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=700 700w, //herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=800 800w, //herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=900 900w, //herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&amp;width=1200 1200w"><noscript>
//                     <img src="//herbolario-salud-natural.myshopify.com/cdn/shop/articles/blog-semillas-propiedades-nutricionales-febrero-2024.jpg?v=1724909485&width=460"
//                         loading="lazy"
//                         class="img-fit" width="1200"
//                         height="599"
//                         alt="Semillas: propiedades medicinales y nutricionales para una vida saludable">
//                     </noscript>
//                         </div>
//                 </a><div class="card__info relative flex flex-col items-start grow">
//                     <div class="flex-auto"><p class="text-theme-light mb-2 text-body-small"><time datetime="2024-08-29T05:31:24Z">29 de agosto de 2024</time>
//                 </p><h2 class="card__title h5"><a href="/blogs/blog/semillas-propiedades-medicinales-y-nutricionales-para-una-vida-saludable" class="card-link text-current">Semillas: propiedades medicinales y nutricionales para una vida saludable</a></h2><p class="text-theme-light text-body-small">
//                         Por Patricia Hueso
//                         </p><p class=" mb-5">${stripHTMLAndLimitWords(node.content, 30)}
//                 </p><a href="/blogs/blog/semillas-propiedades-medicinales-y-nutricionales-para-una-vida-saludable" class="link block mt-5 has-ltr-icon">
//                         Leer más
//                 <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M4.696 12h14.686m-7.007-7.5 7.5 7.5-7.5 7.5"></path></svg></a></div>
//                 </div>
//             </article>`;
//     }
// };
//
//
// const stripHTMLAndLimitWords = (html, wordLimit) =>  {
//     // Elimina todas las etiquetas HTML
//     const text = html.replace(/(<([^>]+)>)/gi, "");
//
//     // Divide el texto en palabras
//     const words = text.split(/\s+/);
//
//     // Retorna las primeras 'wordLimit' palabras unidas por espacios
//     return words.slice(0, wordLimit).join(" ");
// }
// getArticles();

//Esto va sin enseñar el texto descriptivo
// document.addEventListener('DOMContentLoaded', () => {
//     const slideBlog = document.querySelector(".slider__grid--lg");
//     if (!slideBlog) return; // Si no existe el elemento, no hacemos nada
//
//     const tag = slideBlog.getAttribute("data-tag");
//     if (!tag) return; // Si no hay tag, no hacemos nada
//
//     const getArticles = async () => {
//         try {
//             const response = await fetch(
//                 "/api/2024-07/graphql.json",
//                 {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json",
//                         "X-Shopify-Storefront-Access-Token": "504d3712007967498779ec2838ca6d31",
//                     },
//                     body: JSON.stringify({
//                         query: `
//               query GetArticles($tag: String!) {
//                 articles(first: 3, query: $tag) {
//                   edges {
//                     node {
//                       id
//                       title
//                       publishedAt
//                       excerpt
//                       handle
//                       author {
//                         name
//                       }
//                       image {
//                         url
//                       }
//                       blog {
//                         handle
//                       }
//                     }
//                   }
//                 }
//               }
//             `,
//                         variables: {
//                             tag: `tag:${tag}`
//                         }
//                     }),
//                 }
//             );
//
//             const result = await response.json();
//             if (result.data && result.data.articles) {
//                 drawArticles(result.data.articles.edges);
//             }
//         } catch (error) {
//             console.error("Error fetching related blog posts:", error);
//         }
//     };
//
// const drawArticles = (articles) => {
//     slideBlog.innerHTML = ''; // Limpiar el contenedor antes de agregar nuevos artículos
//     articles.forEach(({ node }) => {
//         const publishDate = new Date(node.publishedAt);
//         const formattedDate = publishDate.toLocaleDateString('es-ES', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//         });
//
//         const articleHTML = `
//         <li class="slider__item fade-in cc-animate-init cc-animate-in" data-cc-animate="fade-in" data-cc-animate-delay="0.35s" style="animation-delay: 0.35s;">
//           <article class="card hover:grow-media card--article h-full relative flex flex-col justify-between" id="article-${node.id}">
//             <a href="/blogs/${node.blog.handle}/${node.handle}" class="card__media relative">
//               <div class="media block relative h-full" tabindex="-1" style="padding-top: 56.49717514124294%;">
//                 <img
//                   data-srcset="${node.image.url}&width=320 320w, ${node.image.url}&width=460 460w, ${node.image.url}&width=600 600w, ${node.image.url}&width=700 700w, ${node.image.url}&width=800 800w, ${node.image.url}&width=900 900w, ${node.image.url}&width=1200 1200w"
//                   sizes="(min-width: 1508px) calc((1380px - 48px) / 3), (min-width: 1280px) calc((100vw - 176px) / 3), (min-width: 1024px) calc((100vw - 144px) / 3), (min-width: 600px) calc((100vw - 120px) / 2), calc(100vw - 40px)"
//                   data-src="${node.image.url}&width=460"
//                   src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201200%20599'%3E%3C/svg%3E"
//                   class="img-fit no-js-hidden"
//                   loading="lazy"
//                   width="1200"
//                   height="599"
//                   alt="${node.title}"
//                 >
//               </div>
//             </a>
//             <div class="card__info relative flex flex-col items-start grow">
//               <div class="flex-auto">
//                 <p class="text-theme-light mb-2 text-body-small">
//                   <time datetime="${node.publishedAt}">${formattedDate}</time>
//                 </p>
//                 <h2 class="card__title h5">
//                   <a href="/blogs/${node.blog.handle}/${node.handle}" class="card-link text-current">${node.title}</a>
//                 </h2>
//                 <p class="text-theme-light text-body-small">
//                   Por ${node.author.name}
//                 </p>
//                 <p class="mb-5">${node.excerpt}</p>
//                 <a href="/blogs/${node.blog.handle}/${node.handle}" class="link block mt-5 has-ltr-icon">
//                   Leer más
//                   <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon">
//                     <path d="M4.696 12h14.686m-7.007-7.5 7.5 7.5-7.5 7.5"></path>
//                   </svg>
//                 </a>
//               </div>
//             </div>
//           </article>
//         </li>
//       `;
//         slideBlog.innerHTML += articleHTML;
//     });
// };
//
// getArticles();
// });


// document.addEventListener('DOMContentLoaded', () => {
//     const slideBlog = document.querySelector(".slider__grid--lg");
//     if (!slideBlog) return; // Si no existe el elemento, no hacemos nada
//
//     const tag = slideBlog.getAttribute("data-tag");
//     if (!tag) return; // Si no hay tag, no hacemos nada
//
//     const getArticles = async () => {
//         try {
//             const response = await fetch(
//                 "/api/2024-07/graphql.json",
//                 {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json",
//                         "X-Shopify-Storefront-Access-Token": "504d3712007967498779ec2838ca6d31",
//                     },
//                     body: JSON.stringify({
//                         query: `
//               query GetArticles($tag: String!) {
//                 articles(first: 3, query: $tag) {
//                   edges {
//                     node {
//                       id
//                       title
//                       publishedAt
//                       excerpt
//                       content
//                       handle
//                       author {
//                         name
//                       }
//                       image {
//                         url
//                       }
//                       blog {
//                         handle
//                       }
//                     }
//                   }
//                 }
//               }
//             `,
//                         variables: {
//                             tag: `tag:${tag}`
//                         }
//                     }),
//                 }
//             );
//
//             const result = await response.json();
//             if (result.data && result.data.articles) {
//                 drawArticles(result.data.articles.edges);
//             }
//         } catch (error) {
//             console.error("Error fetching related blog posts:", error);
//         }
//     };
//
//     const getShortDescription = (content, wordLimit = 25) => {
//         // Eliminar etiquetas HTML
//         const plainText = content.replace(/<[^>]*>/g, '');
//         // Dividir en palabras y limitar
//         const words = plainText.split(/\s+/).slice(0, wordLimit);
//         // Unir las palabras y añadir puntos suspensivos si se truncó
//         return words.join(' ') + (words.length === wordLimit ? '...' : '');
//     };
//
//     const drawArticles = (articles) => {
//         slideBlog.innerHTML = ''; // Limpiar el contenedor antes de agregar nuevos artículos
//         articles.forEach(({ node }) => {
//             const publishDate = new Date(node.publishedAt);
//             const formattedDate = publishDate.toLocaleDateString('es-ES', {
//                 year: 'numeric',
//                 month: 'long',
//                 day: 'numeric'
//             });
//
//             const shortDescription = getShortDescription(node.content);
//
//             const articleHTML = `
//             <li class="slider__item fade-in cc-animate-init cc-animate-in" data-cc-animate="fade-in" data-cc-animate-delay="0.35s" style="animation-delay: 0.35s;">
//               <article class="card hover:grow-media card--article h-full relative flex flex-col justify-between" id="article-${node.id}">
//                 <a href="/blogs/${node.blog.handle}/${node.handle}" class="card__media relative">
//                   <div class="media block relative h-full" tabindex="-1" style="padding-top: 56.49717514124294%;">
//                     <img
//                       data-srcset="${node.image.url}&width=320 320w, ${node.image.url}&width=460 460w, ${node.image.url}&width=600 600w, ${node.image.url}&width=700 700w, ${node.image.url}&width=800 800w, ${node.image.url}&width=900 900w, ${node.image.url}&width=1200 1200w"
//                       sizes="(min-width: 1508px) calc((1380px - 48px) / 3), (min-width: 1280px) calc((100vw - 176px) / 3), (min-width: 1024px) calc((100vw - 144px) / 3), (min-width: 600px) calc((100vw - 120px) / 2), calc(100vw - 40px)"
//                       data-src="${node.image.url}&width=460"
//                       src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201200%20599'%3E%3C/svg%3E"
//                       class="img-fit no-js-hidden"
//                       loading="lazy"
//                       width="1200"
//                       height="599"
//                       alt="${node.title}"
//                     >
//                   </div>
//                 </a>
//                 <div class="card__info relative flex flex-col items-start grow">
//                   <div class="flex-auto">
//                     <p class="text-theme-light mb-2 text-body-small">
//                       <time datetime="${node.publishedAt}">${formattedDate}</time>
//                     </p>
//                     <h2 class="card__title h5">
//                       <a href="/blogs/${node.blog.handle}/${node.handle}" class="card-link text-current">${node.title}</a>
//                     </h2>
//                     <p class="text-theme-light text-body-small">
//                       Por ${node.author.name}
//                     </p>
//                     <p class="mb-5">${shortDescription}</p>
//                     <a href="/blogs/${node.blog.handle}/${node.handle}" class="link block mt-5 has-ltr-icon">
//                       Leer más
//                       <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon">
//                         <path d="M4.696 12h14.686m-7.007-7.5 7.5 7.5-7.5 7.5"></path>
//                       </svg>
//                     </a>
//                   </div>
//                 </div>
//               </article>
//             </li>
//           `;
//             slideBlog.innerHTML += articleHTML;
//         });
//     };
//
//     getArticles();
// });


//Hasta aqui FUNCIONA

// document.addEventListener('DOMContentLoaded', () => {
//     console.log("Esto FUNCIONA")
//     const slideBlog = document.querySelector(".slider__grid--lg");
//     if (!slideBlog) return; // Si no existe el elemento, no hacemos nada
//
//
//
//     const productId = slideBlog.getAttribute("data-productId");
//     if (!productId) return; // Si no hay productId, no hacemos nada
//
//     const getArticles = async () => {
//         try {
//             let lastCursor = null;
//             let hasNextPage = true;
//             let articles = [];
//             while(hasNextPage) {
//                 const response = await fetch(
//                     "/api/2024-07/graphql.json",
//                     {
//                         method: "POST",
//                         headers: {
//                             "Content-Type": "application/json",
//                             "X-Shopify-Storefront-Access-Token": "504d3712007967498779ec2838ca6d31",
//                         },
//                         body: JSON.stringify({
//                             query: `{
//                  articles(first:250 ${lastCursor != null ? ", after: \"" + lastCursor + "\"" : ""}) {
//                   edges {
//                     node {
//                       id
//                       title
//                       publishedAt
//                       excerpt
//                       content
//                       handle
//                       author {
//                         name
//                       }
//                       image {
//                         url
//                       }
//                       blog {
//                         handle
//
//                       }
//                       lista_productos: metafield(namespace: "custom", key: "lista_productos") {
//                         value
//                         }
//                     }
//
//                   }
//                    pageInfo {
//                         endCursor
//                         hasNextPage
//                       }
//                 }
//               }
//
//             `
//                         }),
//                     }
//                 );
//
//
//             const result = await response.json();
//             // if (result.data && result.data.articles) {
//             //     drawArticles(result.data.articles.edges);
//             // }
//                 lastCursor = result.data.articles.pageInfo.endCursor;
//                 hasNextPage = result.data.articles.pageInfo.hasNextPage;
//                 console.log('Esto tiene result' , result)
//                 articles = [...articles, ...result.data.articles.edges];
//
//                 // hasNextPage = false
//
//             }
//             console.log('Esto esta funcionando', articles)
//
//             // const filteredArticles = articles.filter((article) => {
//             //         const products = article.node.lista_productos.value
//             //     for (const product of products) {
//             //         if (product.includes(productId)) {
//             //             return article
//             //         }
//             //     }
//             //
//             //  })
//
//             const filteredArticles = articles.filter((article) => article.node.lista_productos && article.node.lista_productos.value.includes(productId))
//             //si no hay nada tengo que hacer un innerhtml vacio del contenedor GENERICO de tod
//             drawArticles(filteredArticles)
//
//
//
//             console.log('Esto esta dentro de article', filteredArticles)
//         } catch (error) {
//             console.error("Error fetching related blog posts:", error);
//         }
//     };
//
//
//     const getShortDescription = (content, charLimit = 120) => {
//         // Eliminar etiquetas HTML
//         const plainText = content.replace(/<[^>]*>/g, '');
//
//         if (plainText.length <= charLimit) {
//             return plainText;
//         }
//
//         // Encontrar el último espacio antes del límite de caracteres
//         let truncated = plainText.substr(0, charLimit);
//         let lastSpaceIndex = truncated.lastIndexOf(' ');
//
//         // Si encontramos un espacio, cortamos ahí. Si no, usamos el límite completo
//         truncated = truncated.substr(0, lastSpaceIndex > 0 ? lastSpaceIndex : charLimit);
//
//         // Añadir puntos suspensivos
//         return truncated.trim() + '...';
//     };
//
//     const drawArticles = (articles) => {
//         slideBlog.innerHTML = ''; // Limpiar el contenedor antes de agregar nuevos artículos
//         articles.forEach(({ node }) => {
//             const publishDate = new Date(node.publishedAt);
//             const formattedDate = publishDate.toLocaleDateString('es-ES', {
//                 year: 'numeric',
//                 month: 'long',
//                 day: 'numeric'
//             });
//
//             const shortDescription = getShortDescription(node.content);
//
//             const articleHTML = `
//             <li class="slider__item fade-in cc-animate-init cc-animate-in" data-cc-animate="fade-in" data-cc-animate-delay="0.35s" style="animation-delay: 0.35s;">
//               <article class="card hover:grow-media card--article h-full relative flex flex-col justify-between" id="article-${node.id}">
//                 <a href="/blogs/${node.blog.handle}/${node.handle}" class="card__media relative">
//                   <div class="media block relative h-full" tabindex="-1" style="padding-top: 56.49717514124294%;">
//                     <img
//                       data-srcset="${node.image.url}&width=320 320w, ${node.image.url}&width=460 460w, ${node.image.url}&width=600 600w, ${node.image.url}&width=700 700w, ${node.image.url}&width=800 800w, ${node.image.url}&width=900 900w, ${node.image.url}&width=1200 1200w"
//                       sizes="(min-width: 1508px) calc((1380px - 48px) / 3), (min-width: 1280px) calc((100vw - 176px) / 3), (min-width: 1024px) calc((100vw - 144px) / 3), (min-width: 600px) calc((100vw - 120px) / 2), calc(100vw - 40px)"
//                       data-src="${node.image.url}&width=460"
//                       src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201200%20599'%3E%3C/svg%3E"
//                       class="img-fit no-js-hidden"
//                       loading="lazy"
//                       width="1200"
//                       height="599"
//                       alt="${node.title}"
//                     >
//                   </div>
//                 </a>
//                 <div class="card__info relative flex flex-col items-start grow">
//                   <div class="flex-auto">
//                     <p class="text-theme-light mb-2 text-body-small">
//                       <time datetime="${node.publishedAt}">${formattedDate}</time>
//                     </p>
//                     <h2 class="card__title h5">
//                       <a href="/blogs/${node.blog.handle}/${node.handle}" class="card-link text-current">${node.title}</a>
//                     </h2>
//                     <p class="text-theme-light text-body-small">
//                       Por ${node.author.name}
//                     </p>
//                     <p class="mb-5">${shortDescription}</p>
//                     <a href="/blogs/${node.blog.handle}/${node.handle}" class="link block mt-5 has-ltr-icon">
//                       Leer más
//                       <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon">
//                         <path d="M4.696 12h14.686m-7.007-7.5 7.5 7.5-7.5 7.5"></path>
//                       </svg>
//                     </a>
//                   </div>
//                 </div>
//               </article>
//             </li>
//           `;
//             slideBlog.innerHTML += articleHTML;
//         });
//     };
//
//     getArticles();
// });
document.addEventListener('DOMContentLoaded', () => {
    const slideBlog = document.querySelector(".slider__grid--lg");
    if (!slideBlog) return; // Si no existe el elemento, no hacemos nada

    const productId = slideBlog.getAttribute("data-productId");
    if (!productId) return; // Si no hay productId, no hacemos nada

    const getArticles = async () => {
        try {
            let lastCursor = null;
            let hasNextPage = true;
            let articles = [];
            while(hasNextPage) {
                const response = await fetch(
                    "/api/2024-07/graphql.json",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Shopify-Storefront-Access-Token": "504d3712007967498779ec2838ca6d31",
                        },
                        body: JSON.stringify({
                            query: `{
                 articles(first:250 ${lastCursor != null ? ", after: \"" + lastCursor + "\"" : ""}) {
                  edges {
                    node {
                      id
                      title
                      
                      publishedAt
                      excerpt
                      content
                      handle
                      author {
                        name
                      }
                      image {
                        url
                      }
                      blog {
                        handle
                      }    
                      lista_productos: metafield(namespace: "custom", key: "lista_productos") {
                        value
                        }
                    }
                  }
                   pageInfo {
                        endCursor
                        hasNextPage
                      }
                }
              }
            `
                        }),
                    }
                );

                const result = await response.json();
                lastCursor = result.data.articles.pageInfo.endCursor;
                hasNextPage = result.data.articles.pageInfo.hasNextPage;
                articles = [...articles, ...result.data.articles.edges];
            }

            const filteredArticles = articles.filter((article) => article.node.lista_productos && article.node.lista_productos.value.includes(productId))

            // Ocultar la sección "Featured blog" si no hay artículos
            const featuredBlogSection = document.querySelector('.cc-featured-blog');
            if (featuredBlogSection) {
                if (filteredArticles.length === 0) {
                    featuredBlogSection.style.display = 'none';
                } else {
                    featuredBlogSection.style.display = 'block';
                }
            }

            drawArticles(filteredArticles)

        } catch (error) {
            console.error("Error fetching related blog posts:", error);
        }
    };

    const getShortDescription = (content, charLimit = 120) => {
        const plainText = content.replace(/<[^>]*>/g, '');

        if (plainText.length <= charLimit) {
            return plainText;
        }

        let truncated = plainText.substr(0, charLimit);
        let lastSpaceIndex = truncated.lastIndexOf(' ');

        truncated = truncated.substr(0, lastSpaceIndex > 0 ? lastSpaceIndex : charLimit);

        return truncated.trim() + '...';
    };

    const drawArticles = (articles) => {
        slideBlog.innerHTML = ''; // Limpiar el contenedor antes de agregar nuevos artículos
        articles.forEach(({ node }) => {
            const publishDate = new Date(node.publishedAt);
            const formattedDate = publishDate.toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            const shortDescription = getShortDescription(node.content);

            // Asegúrate de que la URL de la imagen sea válida
            const imageUrl = node.image && node.image.url ? node.image.url : '/path/to/default/image.jpg';

            const articleHTML = `
            <li class="slider__item fade-in cc-animate-init cc-animate-in" data-cc-animate="fade-in" data-cc-animate-delay="0.35s" style="animation-delay: 0.35s;">
              <article class="card hover:grow-media card--article h-full relative flex flex-col justify-between" id="article-${node.id}">
                <a href="/blogs/${node.blog.handle}/${node.handle}" class="card__media relative">
                  <div class="media block relative h-full" tabindex="-1" style="padding-top: 56.49717514124294%;">
                    <img
                      srcset="${imageUrl}&width=320 320w, ${imageUrl}&width=460 460w, ${imageUrl}&width=600 600w, ${imageUrl}&width=700 700w, ${imageUrl}&width=800 800w, ${imageUrl}&width=900 900w, ${imageUrl}&width=1200 1200w"
                      sizes="(min-width: 1508px) calc((1380px - 48px) / 3), (min-width: 1280px) calc((100vw - 176px) / 3), (min-width: 1024px) calc((100vw - 144px) / 3), (min-width: 600px) calc((100vw - 120px) / 2), calc(100vw - 40px)"
                      src="${imageUrl}&width=460"
                      class="img-fit no-js-hidden"
                      loading="lazy"
                      width="1200"
                      height="599"
                      alt="${node.title}"
                    >
                  </div>
                </a>
                <div class="card__info relative flex flex-col items-start grow">
                  <div class="flex-auto">
                    <p class="text-theme-light mb-2 text-body-small">
                      <time datetime="${node.publishedAt}">${formattedDate}</time>
                    </p>
                    <h2 class="card__title h5">
                      <a href="/blogs/${node.blog.handle}/${node.handle}" class="card-link text-current">${node.title}</a>
                    </h2>
                    <p class="text-theme-light text-body-small">
                      Por ${node.author.name}
                    </p>
                    <p class="mb-5">${shortDescription}</p>
                    <a href="/blogs/${node.blog.handle}/${node.handle}" class="link block mt-5 has-ltr-icon">
                      Leer más
                      <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon">
                        <path d="M4.696 12h14.686m-7.007-7.5 7.5 7.5-7.5 7.5"></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </article>
            </li>
          `;
            slideBlog.innerHTML += articleHTML;
        });
    };

    getArticles();
});